// extracted by mini-css-extract-plugin
export default {"supportContainer":"styles_supportContainer__iql+y","content":"styles_content__lG5Ar"};